import { ColData } from 'ufinet-web-components'
import { IntlShape } from 'react-intl';

export const colsConfigLiquidateColData = (intl: IntlShape): ColData[] => [
  // header is the id to search the translate based on the data received
  // removing or typing the word false in the property nonFilterable is gonna show in the table header the filter
  // body you can customize the data you want to show, accept react component or just a simple html
  {
    field: 'id', header: 'COL.CONFIG.ID', width: '20%', nonFilterable: false, editable: true, nonSortable: false, filterType: 'number',
    // body: (row: any) => <PercentangeCommission percentange={row.percentage} />
  },
  {
    field: 'companyName', header: 'COL.COMMISSION.ENTERPRISE', width: '20%', nonFilterable: false, editable: true, nonSortable: false, filterType: 'text',
    // body: (row: any) => <PercentangeCommission percentange={row.percentage} />
  },
  {
    field: 'executionDay', header: 'COL.EXECUTIONDAY', width: '20%', nonFilterable: false, editable: true, nonSortable: false, filterType: 'number',
    // body: (row: any) => <PercentangeCommission percentange={row.percentage} />
  },

]


